import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { FileReaderEvent } from '../../../../shared/models/FileReader';
import { WsreService } from '../../wsre.service';
import { IdlerPartImageReqVM, SaveNewPhotoOnComponentWSREModelRequest, SaveNewPhotoOnDipTestWSREModelRequest } from '../../models/wsre.model';
import { NotificationsService } from 'angular2-notifications';
import { WSREPhotoUpload } from '../../pages/repair-estimate/repair-estimate.component';
import { heicTo } from 'heic-to';


@Component({
  selector: 'upload-photo-wsre',
  templateUrl: './upload-photo-wsre.component.html',
  styleUrls: ['./upload-photo-wsre.component.scss']
})




export class UploadPhotoWsreComponent implements OnInit {
  // @Input()
  // wsreId: number;

  @Input()
  uploadEndPoint: number;

  @Input()
  relatedId: number;

  @Input() ComponentTypeId: number;
  @Output() onPhotoUpload: EventEmitter<any> = new EventEmitter();

  photo = '';
  photoLoading = false;

  constructor(private _wsreService: WsreService,
    private _notify: NotificationsService,
    ) { }

  ngOnInit() {
    if (this.ComponentTypeId === undefined || this.ComponentTypeId === null) {
    this.ComponentTypeId = 1;
  }
  }


  sucessfullyUploaded(title: string, message: string, image: string) {
    this._notify.success(title, message);
    this.onPhotoUpload.emit(true);
  }

  errorMessage() {
    this._notify.error('Error', 'Unable to update the photo. Please contact TrackTreads support. ');
  }

  resizeBase64Img(base64, newWidth, newHeight) {
    return new Promise((resolve, reject)=>{
        var canvas = document.createElement("canvas");
        canvas.style.width = newWidth.toString()+"px";
        canvas.style.height = newHeight.toString()+"px";
        let context = canvas.getContext("2d");
        let img = document.createElement("img");
        img.src = base64;
        img.onload = function () {
            context.scale(newWidth/img.width,  newHeight/img.height);
            context.drawImage(img, 0, 0); 
            resolve(canvas.toDataURL());               
        }
    });
}


  uploadPhoto(newPhoto: string) {
     this.photoLoading = true;
     let IdlarPartImage =  new IdlerPartImageReqVM();

     


     switch (+this.uploadEndPoint) {
       case +WSREPhotoUpload.component:
          const componentRequest =  new SaveNewPhotoOnComponentWSREModelRequest(this.relatedId, newPhoto, this.ComponentTypeId);
          this._wsreService.SavePhotoToComponentRecord(componentRequest).subscribe(r => {
            this.photoLoading = false;
            if ( r >= 0) {
              this.sucessfullyUploaded('Uploaded', 'Component photo has been successfully uploaded', newPhoto);
            }      else {
              this.errorMessage();
            }
          });
        break;
        case +WSREPhotoUpload.dipTest:
        const dipTestRequest =  new SaveNewPhotoOnDipTestWSREModelRequest(this.relatedId, newPhoto);
        this._wsreService.SavePhotoToDipTestRecord(dipTestRequest).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Dip Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 3:
        const _ArrivalPhoto =  new SaveNewPhotoOnDipTestWSREModelRequest(this.relatedId, newPhoto);
        this._wsreService.SaveArrivalPhoto(_ArrivalPhoto).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Arrival photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 4:
        const _customerReferencePhoto =  new SaveNewPhotoOnDipTestWSREModelRequest(this.relatedId, newPhoto);
        this._wsreService.SaveCustomerReferencePhotos(_customerReferencePhoto).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Customer Reference photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 5:
        const _oldTagPhoto =  new SaveNewPhotoOnDipTestWSREModelRequest(this.relatedId, newPhoto);
        this._wsreService.SaveOldTagPhotos(_oldTagPhoto).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Old Tag photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 6:
        const _crackTestPhoto =  new SaveNewPhotoOnDipTestWSREModelRequest(this.relatedId, newPhoto);
        this._wsreService.SaveCrackTestImage(_crackTestPhoto).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 7:
        
        IdlarPartImage.PartId=1;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
        case 8:
       
        IdlarPartImage.PartId=2;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 9:
       
        IdlarPartImage.PartId=3;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 10:
       
        IdlarPartImage.PartId=4;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
    case 11:
       
        IdlarPartImage.PartId=5;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 12:
       
        IdlarPartImage.PartId=6;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 13:
       
        IdlarPartImage.PartId=7;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 14:
       
        IdlarPartImage.PartId=8;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 15:
       
        IdlarPartImage.PartId=9;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Crack Test photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 16:
       
        IdlarPartImage.PartId=10;
        IdlarPartImage.ComponentRecordID = this.relatedId;
        IdlarPartImage.PhotoData=newPhoto;

        this._wsreService.SaveIdlerPartImages(IdlarPartImage).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
      case 17:
       
        const _finalPhoto =  new SaveNewPhotoOnDipTestWSREModelRequest(this.relatedId, newPhoto);
        this._wsreService.SaveFinalPhoto(_finalPhoto).subscribe(r => {
          this.photoLoading = false;
          if ( r >= 0) {
            this.sucessfullyUploaded('Uploaded', 'Arrival photo has been successfully uploaded', newPhoto);
          }      else {
            this.errorMessage();
          }
        });
      break;
        default: break;
     }
  }



  // onSelectPhoto(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(event.target.files[0]);
  //     reader.onload = (event: any) => {

  //       const imageUrl = (event.target["result"]);
  //       //resize photo
  //       this.compressImage(imageUrl).then((res: string) => {
  //         // console.log("imageUrl", res)
  //         if (res) {
  //          //console.log('res', res)

  //           //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
  //           this.uploadPhoto(res.split(',')[1]);
  //         }
  //       })
  //       //this.uploadPhoto(event.target.result.split(',')[1]);
  //     };
  //   }
  // }

  // onSelectPhoto(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     this.photoLoading = true;
  //     let file = event.target.files[0];
  //     const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(f);
  //       reader.onload = (e: any) => {
  //         const imageUrl = e.target.result;
  //         this.compressImage(imageUrl).then((res: string) => {
  //           if (res) {
  //             this.uploadPhoto(res.split(',')[1]);
  //           }
  //         });
  //       };
  //     };
  //     if (isHeic) {
  //       (heic2any as any).default({
  //         blob: file,
  //         toType: "image/jpeg",
  //         quality: 0.8
  //       })
  //       .then((result: any) => {
  //         const convertedBlob = Array.isArray(result) ? result[0] : result;
  //         const convertedFile = new File([convertedBlob], "converted.jpg", {
  //           type: "image/jpeg"
  //         });
  //         processFile(convertedFile);
  //       })
  //       .catch((err: any) => {
  //         console.error("HEIC conversion failed", err);
  //         alert("Unable to process HEIC image");
  //       });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }

  async onSelectPhoto(event: any): Promise<void> {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  this.photoLoading = true;

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = e.target.result;

      this.compressImage(imageUrl)
        .then((res: string) => {

          if (res) {
            this.uploadPhoto(res.split(',')[1]);
          }

        })
        .catch(err => {

          this.photoLoading = false;
          console.error(err);

        });

    };

    reader.readAsDataURL(f);

  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg", // Change to "toType" if your heic-to version requires it
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    console.error("HEIC conversion failed", err);

    alert("Unable to process HEIC image");

  }

  // Allow selecting the same file again
  event.target.value = null;

}


  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();




      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');

        let width, height;
        width = img.width;
        height = img.height;

        console.log('width', width)
        console.log('height', height)

        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height


        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }
}




